import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { ThemeMarquee } from '@/components/landing/theme-marquee'
import { ProblemSection } from '@/components/landing/problem-section'
import { SolutionSection } from '@/components/landing/solution-section'
import { AppShowcase } from '@/components/landing/app-showcase'
import { CalculatorSection } from '@/components/landing/calculator-section'
import { OfferSection } from '@/components/landing/offer-section'
import { ResearchSection } from '@/components/landing/research-section'
import { MakerSection } from '@/components/landing/maker-section'
import { PricingSection } from '@/components/landing/pricing-section'
import { SignupSection } from '@/components/landing/signup-section'
import { FaqSection } from '@/components/landing/faq-section'
import { ClosingCta } from '@/components/landing/closing-cta'
import { MobileCta } from '@/components/landing/mobile-cta'
import { siteConfig } from '@/constants/site'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo ogImage={siteConfig.ogImage} />

            <HeroSection />
            <ThemeMarquee />
            <ProblemSection />
            <SolutionSection />
            <AppShowcase />
            <CalculatorSection />
            <OfferSection />
            <ResearchSection />
            <MakerSection />
            <PricingSection />
            <SignupSection />
            <FaqSection />
            <ClosingCta />
            <MobileCta />
        </Layout>
    )
}

export default Home
